import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      const token = localStorage.getItem('token');
      fetch(`${API_URL}/api/payments/status/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(r => r.json())
        .then(d => setStatus(d))
        .catch(() => setStatus({ paid: false }))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#F6F5F0' }}>
      <div className="max-w-md w-full text-center" style={{ background: '#fff', border: '1px solid #E2DDD3', borderRadius: '12px', padding: '3rem 2rem' }}>
        {loading ? (
          <>
            <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4" style={{ color: '#C5A55A' }} />
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#0B1D3A', fontSize: '1.5rem' }}>Verificando pago...</h2>
          </>
        ) : status?.paid ? (
          <>
            <CheckCircle className="w-16 h-16 mx-auto mb-4" style={{ color: '#27ae60' }} />
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#0B1D3A', fontSize: '1.75rem', marginBottom: '1rem' }} data-testid="payment-success-title">Pago realizado con exito</h2>
            <p style={{ color: '#4A4A5A', marginBottom: '0.5rem' }}>Hemos enviado la factura y nota fiscal a su email.</p>
            <p style={{ color: '#4A4A5A', marginBottom: '2rem' }}>Nuestro equipo procedera con su tramite a la mayor brevedad.</p>
            {status.order && (
              <div style={{ background: '#F6F5F0', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem', textAlign: 'left' }}>
                <p style={{ fontSize: '0.9rem', color: '#4A4A5A' }}><strong>Factura:</strong> {status.order.invoice_number}</p>
                <p style={{ fontSize: '0.9rem', color: '#4A4A5A' }}><strong>Servicio:</strong> {status.order.service_name}</p>
                <p style={{ fontSize: '0.9rem', color: '#4A4A5A' }}><strong>Importe:</strong> {status.order.amount} EUR</p>
              </div>
            )}
            <Link to="/dashboard">
              <Button style={{ background: '#C5A55A', color: '#0B1D3A', fontWeight: 700 }} data-testid="go-dashboard-btn">Ir al Panel</Button>
            </Link>
          </>
        ) : (
          <>
            <XCircle className="w-16 h-16 mx-auto mb-4" style={{ color: '#c0392b' }} />
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#0B1D3A', fontSize: '1.5rem', marginBottom: '1rem' }}>Pago no completado</h2>
            <p style={{ color: '#4A4A5A', marginBottom: '2rem' }}>El pago no se ha procesado. Puede intentarlo de nuevo.</p>
            <Link to="/dashboard">
              <Button style={{ background: '#C5A55A', color: '#0B1D3A', fontWeight: 700 }}>Volver al Panel</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
